exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0ab8e17e] .table-full .v-datatable.v-table>tbody{max-height:calc(100vh - 486px);min-height:calc(100vh - 486px)}.custom_btn_close[data-v-0ab8e17e]{position:absolute!important;right:24px!important}", ""]);

// exports
